// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// modules
import * as R from 'ramda'
import { merge, Subject } from 'rxjs'
import { buffer, delay, filter, publish, tap } from 'rxjs/operators'
import wsCreator, {
  send as wsSend,
  sendNow as wsSendNow,
  wsGet as wsGetImport,
  wsGetNow as wsGetNowImport,
} from 'weblite-frontend-ws-client'
import { LocalFind } from '@weblite/persist'
import {
  IAction,
  RequestAction,
  ResponseAction,
} from '@weblite/ts-action/types'
// actions
import { DATA_USER_CONNECT } from '@weblite/action/gateway'
import { DATA_AUTH_SIGNOUT } from '@weblite/action/auth'
import { buildNumber, version } from '$config/env'
import hostConf from '$config/frontend'
// views
import { connectionStatusView } from '$comp/main/root.reducer'
import { serverSub } from '$func/subscription'
import { getAuthToken } from '$logic/auth'
// setup
import { features } from '$setup/features'
import onDisconnection from '../hooks/after/disconnection'
import onConnection from '../hooks/after/connection'

// const
const wsInitiator = () => {
  const compression = LocalFind('ws:compression')
  let url = `${
    hostConf.WS_HOST
  }/${getAuthToken()}?version=${version}&build=${buildNumber}`
  if (compression !== false) {
    url += `&compress=${compression || 'zlib'}`
  }
  url += `&features=${[...features].join(',')}`

  return new window.WebSocket(url)
}

// ws hooks
const hooks = {
  onConnection,
  onDisconnection,
  shouldSend: () => connectionStatusView() === 'connected',
}

export const send = (action: any, save?: boolean, retry?: number) =>
  wsSend(action, { save, retry })

export const sendNow = wsSendNow

export const wsReq = wsGetImport

export const wsRequest = async action => {
  const res = await wsGetImport(action)
  if (res.type !== action.type) serverSub.publish(res)
  return res
}

export const wsGetNow = wsGetNowImport

const decider$ = new Subject()
export const changeConnectionStatus = () => decider$.next()

export const { connect, terminateConnection } = (() => {
  const instantActions = new Set([DATA_USER_CONNECT, DATA_AUTH_SIGNOUT])

  let subscriber
  let wsCreatorData

  const createNewWebsocket = () => {
    wsCreatorData = wsCreator(wsInitiator, hooks)

    const wsCreator$ = wsCreatorData.ws$.pipe(publish())
    const serverMessage$ = wsCreator$.pipe(
      filter(action => {
        if (!instantActions.has(action.type)) return true

        serverSub.publish(action)
        return false
      }),
      // TODO #verify https://rxjs.dev/6-to-7-change-summary#buffer
      buffer(
        merge(decider$, wsCreator$).pipe(
          filter(() => connectionStatusView() === 'connected'),
          delay(0),
        ),
      ),
      tap(R.forEach(action => serverSub.publish(action))),
    )

    subscriber = serverMessage$.subscribe()
    setTimeout(() => wsCreator$.connect(), 0)
  }

  return {
    connect: () => {
      if (wsCreatorData) wsCreatorData.reConnect()
      else createNewWebsocket()
    },
    terminateConnection: () => {
      if (!wsCreatorData) return
      wsCreatorData.terminateConnection()
      subscriber.unsubscribe()
      wsCreatorData = null
    },
  }
})()

// TODO: will be merged by wsReq
// TODO: error are partial remove with function overloading
export function request<A extends IAction>(
  input: RequestAction<A['Req']>,
  sendOptions?: { save?: boolean; retry?: number },
): Promise<ResponseAction<A['Res']>, ResponseAction<A['ErrorCodes']>> {
  return wsReq(input, sendOptions)
}

export function requestNow<A extends IAction>(
  input: RequestAction<A['Req']>,
): Promise<ResponseAction<A['Res']>, ResponseAction<A['ErrorCodes']>> {
  return wsGetNow(input)
}
